import { IconAlertTriangle } from '@tabler/icons-react';
import ContentDialog from '@/Pages/Sessions/uiComponents/ContentDialog/ContentDialog';

interface UnsupportedLanguageWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const UnsupportedLanguageWarningModal = ({ isOpen, onClose }: UnsupportedLanguageWarningModalProps) => (
  <ContentDialog isOpen={isOpen} setIsOpen={onClose} size="medium" hideCloseIcon={false}>
    <div className="flex flex-col items-center justify-center p-6">
      <IconAlertTriangle size={48} className="mb-4 text-amber-500" />
      <h2 className="mb-2 text-center text-xl font-bold">Translation Not Supported</h2>
      <p className="mb-4 text-center text-sm text-slate-600">
        Clip caption translation currently supports English and European languages, including Spanish, German, Italian,
        French, Dutch, and Portuguese.
        <br />
        <br />
        Translation feature is not available for videos in any other languages at this time.
      </p>
      <button
        onClick={onClose}
        className="rounded-md bg-slate-800 px-4 py-2 text-sm font-medium text-white hover:bg-slate-700"
      >
        Got it
      </button>
    </div>
  </ContentDialog>
);
